import { PayLater_ReceiptMaster_Create, PayLater_ReceiptMaster_Delete, PayLater_ReceiptMaster_GetAmountByPRRN } from "src/app/GlobalVariable"
import { Observable } from "rxjs"
import { inject, Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { GetAmountByPRRNDTO } from "../razorpay/razorpay.interface"
import { GetAmountByPRRNResponseDTO, ReceiptMasterCreateRequestDTO, ReceiptMasterCreateResponseDTO, ReceiptMasterDeleteDTO } from "./receiptMaster.interface"

@Injectable({ providedIn: 'root' })
export class PaylaterReceiptMasterService {

     http = inject(HttpClient)
    
    //ReceiptMaster Create
    ReceiptMaster_Create(data: ReceiptMasterCreateRequestDTO): Observable<ReceiptMasterCreateResponseDTO>{
        return this.http.post<ReceiptMasterCreateResponseDTO>(PayLater_ReceiptMaster_Create, data)
    }
    //Delete
    ReceiptMaster_Delete(data: ReceiptMasterDeleteDTO): Observable<void>{
        return this.http.post<void>(PayLater_ReceiptMaster_Delete, data)
    }
    //GetAmountByPRRN
    ReceiptMaster_GetAmountByPRRN(data: GetAmountByPRRNDTO): Observable<GetAmountByPRRNResponseDTO> {
        return this.http.post<GetAmountByPRRNResponseDTO>(PayLater_ReceiptMaster_GetAmountByPRRN, data)
    }
}